import Model from './BaseModel';
import Race from '@/Models/Race';

export default class RacingMultiLegEvent extends Model {
	resourceName() {
		return 'racing_multi_leg_events';
	}

	fields() {
		return ['meeting_id', 'product', 'bet_type', 'race_ids'];
	}

	relationships() {
		return {
			races: new Race()
		};
	}
}
